module.exports = __webpack_public_path__ + "img/content1-6.186bf8c4.webp";